// @ts-nocheck
import { ReactComponent as Icon } from '../../assets/icons/pdfIconSmall.svg';

export default function () {
  return <Icon className="MuiSvgIcon-root" alt="Active" aria-label="Active" />;
}
